import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

import { SimulationService } from "@services/simulation.service";
import { InvestService } from '@services/invest.service';
import { Invest } from '@classes/invest/invest';

@Injectable()
export class InvestResolver implements Resolve<Invest> {
    constructor(
        private simuSrv: SimulationService,
        private investSrv: InvestService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Invest> {
        const localSimu = this.simuSrv.localSimu;

        if(localSimu && localSimu.isEditable) {
            return this.investSrv.get(localSimu.code)
            .pipe(
                catchError(() => {
                    return of(null);
                })
            );
        }

        return of(null);

        // return this.investSrv.get('code');
    }
}
